module.exports = __webpack_public_path__ + "static/media/47.04e78892.webp";